import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import apiClient from "@/modules/request.module.v2";
import {
  addErrorNotification,
  addInfoNotification,
} from "@/components/framework/notify";

export default (companyId) => {
  const history = useHistory();

  return useMutation({
    mutationKey: ["reactivateCompanyAccount", companyId],
    mutationFn: () => {
      return apiClient.post(
        `/companies/reactivate-company/${companyId}`,
        undefined,
        { params: { companyId } },
      );
    },
    onSuccess: (mutationResponse) => {
      history.push(`/${mutationResponse?.data?.urlAlias}`);
      addInfoNotification({ tid: "services.account_reactivated" });
    },
    onError: () => {
      addErrorNotification({ tid: "generic.unknown_error" });
    },
  });
};
